import { useIntl } from 'react-intl';
import { formatMessage } from './config';

export function useTranslation() {
  const intl = useIntl();

  return {
    t: (id: string, values?: Record<string, any>) =>
      formatMessage(intl, id, values),
    intl,
  };
}
